import {addParamToUrl, getUrlParameter} from "./urlUtils";

export function setOffset(value) {
    localStorage.setItem("filterOffset", value);
}

export function getOffset() {
    return parseInt(localStorage.getItem("filterOffset"));
}

export function setReachedEnd(value) {
    if(value !== false) {
        localStorage.setItem("filterReachedEnd", "1");
    } else {
        localStorage.removeItem("filterReachedEnd");
    }
}

export function reachedEnd() {
    return localStorage.hasOwnProperty("filterReachedEnd");
}

export function setLoading(value) {
    if(value !== false) {
        localStorage.setItem("filterLoading", "1");
    } else {
        localStorage.removeItem("filterLoading");
    }
}

export function isLoading() {
    return localStorage.hasOwnProperty("filterLoading");
}

export function resetFilter() {
    localStorage.removeItem("filterLoading");
    localStorage.removeItem("filterReachedEnd");
    localStorage.removeItem("filterPriceMin");
    localStorage.removeItem("filterPriceMax");
    localStorage.removeItem("filterCountry");
    localStorage.removeItem("filterCountryName");
    localStorage.removeItem("filterCity");
    localStorage.removeItem("filterSizes");
    localStorage.removeItem("filterSizeNames");
    localStorage.removeItem("filterQualities");
    localStorage.removeItem("filterQualityNames");
    localStorage.removeItem("filterColors");
    localStorage.removeItem("filterColorNames");
    localStorage.removeItem("filterOffset");

    window.history.replaceState({}, document.title, "/");

    location.reload();
}

export function fillGetParamsFromStorage() {
    if(localStorage.hasOwnProperty("filterCountry")) {
        addParamToUrl("country", localStorage.getItem("filterCountry"));
    }

    if(localStorage.hasOwnProperty("filterCity")) {
        addParamToUrl("city", localStorage.getItem("filterCity"));
    }

    if(localStorage.hasOwnProperty("filterSizes")) {
        addParamToUrl("sizes", localStorage.getItem("filterSizes"));
    }

    if(localStorage.hasOwnProperty("filterQualities")) {
        addParamToUrl("qualities", localStorage.getItem("filterQualities"));
    }

    if(localStorage.hasOwnProperty("filterColors")) {
        addParamToUrl("colors", localStorage.getItem("filterColors"));
    }

    if(localStorage.hasOwnProperty("filterPriceMin")) {
        addParamToUrl("price_min", localStorage.getItem("filterPriceMin"));
    }

    if(localStorage.hasOwnProperty("filterPriceMax")) {
        addParamToUrl("price_max", localStorage.getItem("filterPriceMax"));
    }
}

export function parseGetParams() {
    let country = getUrlParameter("country");
    if(country) {
        let countryId = parseInt(country);
        if(countryId > 0) {
            localStorage.setItem("filterCountry", countryId);
            const select = document.getElementById("filter_country");
            select.value = countryId;
        }
    } else {
        localStorage.removeItem("filterCountry");
        localStorage.removeItem("filterCountryName");
    }

    let city = getUrlParameter("city");
    if(city) {
        localStorage.setItem("filterCity", city);
        const select = document.getElementById("filter_city");
        select.value = city;
    } else {
        localStorage.removeItem("filterCity");
    }

    let sizes = getUrlParameter("sizes");
    if(sizes) {
        console.log("got from url " + sizes);
        localStorage.setItem("filterSizes", sizes);

        let sizesArray = sizes.split(",");
        console.log(sizesArray);
        for(let i = 0; i < sizesArray.length; i++) {
            let size = sizesArray[i];
            let el = document.getElementById("filter_size_" + size);
            
            if(el) {
                el.checked = true;
            }
        }
    } else {
        localStorage.removeItem("filterSizes");
        localStorage.removeItem("filterSizeNames");
    }

    let qualities = getUrlParameter("qualities");
    if(qualities) {
        console.log("got from url " + qualities);
        localStorage.setItem("filterQualities", qualities);

        let array = qualities.split(",");
        for(let i = 0; i < array.length; i++) {
            let match = array[i];
            let el = document.getElementById("filter_quality_" + match);
            if(el) {
                el.checked = true;
            }
        }
    } else {
        localStorage.removeItem("filterQualities");
        localStorage.removeItem("filterQualityNames");
    }

    let colors = getUrlParameter("colors");
    if(colors) {
        console.log("got from url " + colors);
        localStorage.setItem("filterColors", colors);

        let array = colors.split(",");
        for(let i = 0; i < array.length; i++) {
            let match = array[i];
            let el = document.getElementById("filter_color_" + match);
            if(el) {
                el.checked = true;
            }
        }
    } else {
        localStorage.removeItem("filterColors");
        localStorage.removeItem("filterColorNames");
    }

    let priceMin = getUrlParameter("price_min");
    if(priceMin) {
        let priceMinValue = parseInt(priceMin);
        if(priceMinValue > 0) {
            localStorage.setItem("filterPriceMin", priceMinValue);
            const el = document.getElementById("filter_price_price_min");
            el.value = priceMinValue;
        }
    } else {
        localStorage.removeItem("filterPriceMin");
    }

    let priceMax = getUrlParameter("price_max");
    if(priceMax) {
        let priceMaxValue = parseInt(priceMax);
        if(priceMaxValue > 0) {
            localStorage.setItem("filterPriceMax", priceMaxValue);
            const el = document.getElementById("filter_price_price_max");
            el.value = priceMaxValue;
        }
    } else {
        localStorage.removeItem("filterPriceMax");
    }

    let currency = getUrlParameter("currency");
    if(currency.length > 0) {
        localStorage.setItem("filterCurrency", currency);
        const el = document.getElementById("filter_price_price_max");
        el.value = priceMaxValue;
    } else {
        localStorage.removeItem("filterCurrency");
    }
}




